import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import whobanner from "../img/quote.png";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const API_URL = "https://api.securxperts.com:8000/forms/quotation";

const RequestQuoteDesign = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    countrycode: "+91",
    phone: "",
    service: "",
    message: "",
  });

  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const nameRegex = /^[A-Za-z\s]+$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^[0-9]{10}$/;


const [showModal, setShowModal] = useState(false);
const [modalData, setModalData] = useState({ type: "", message: "" });


  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.body.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? (window.scrollY / totalHeight) * 100 : 0;
      setScrollProgress(progress);
      setShowScroll(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const scrollToTop = () =>
  //   window.scrollTo({ top: 0, behavior: "smooth" });

const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "name") {
    if (!/^[A-Za-z\s]*$/.test(value)) return;
  }

  if (name === "phone") {
    if (!/^[0-9]*$/.test(value)) return;
    if (value.length > 10) return;
  }

  setFormData((prev) => ({ ...prev, [name]: value }));
};




  const isValidPhoneNumber = (number, countryCode) => {
    try {
      const phoneNumber = parsePhoneNumberFromString(
        `${countryCode}${number}`
      );
      return phoneNumber ? phoneNumber.isValid() : false;
    } catch {
      return false;
    }
  };

  const openModal = (type, message) => {
  setModalData({ type, message });
  setShowModal(true);

  // scroll to top AFTER popup appears
  // setTimeout(() => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }, 50);

  // auto close after 5 seconds
  setTimeout(() => {
    setShowModal(false);
  }, 5000);
};


 const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  // setStatus({ type: "", message: "" });

  // Empty check
  if (
    !formData.name ||
    !formData.email ||
    !formData.phone ||
    !formData.service ||
    !formData.message
  ) {
    setStatus({ type: "error", message: "Please fill all fields." });
    setIsSubmitting(false);
    return;
  }

  // Name validation
 if (!formData.name || !formData.email || !formData.phone || !formData.service || !formData.message) {
  openModal("error", "Please fill all fields.");
  setIsSubmitting(false);
  return;
}

if (!nameRegex.test(formData.name)) {
  openModal("error", "Name should contain only alphabets.");
  setIsSubmitting(false);
  return;
}

if (!emailRegex.test(formData.email)) {
  openModal("error", "Please enter a valid email address.");
  setIsSubmitting(false);
  return;
}

if (!phoneRegex.test(formData.phone)) {
  openModal("error", "Phone number must be exactly 10 digits.");
  setIsSubmitting(false);
  return;
}

const validPhone = isValidPhoneNumber(
  formData.phone,
  formData.countrycode
);

if (!validPhone) {
  openModal("error", "Please enter a valid phone number for the selected country.");
  setIsSubmitting(false);
  return;
}



  const payload = {
  name: formData.name,
  email: formData.email,
  country_code: formData.countrycode,
  phoneno: formData.phone,
  service: formData.service,
  message: formData.message,
};


    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed");
      openModal(
  "success",
  "Your request has been submitted successfully."
);

// reset form
setFormData({
  name: "",
  email: "",
  countrycode: "+91",
  phone: "",
  service: "",
  message: "",
});

      setStatus({
        type: "success",
        message: "Your request has been submitted successfully.",
      });
//       setTimeout(() => {
//   setStatus({ type: "", message: "" });
// }, 5000);
// window.scrollTo({
//   top: 0,
//   behavior: "smooth",
// });


      setFormData({
        name: "",
        email: "",
        countrycode: "+91",
        phone: "",
        service: "",
        message: "",
      });
    } catch {
       openModal(
    "error",
    "Something went wrong. Please try again."
  );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />

      {/* Banner */}
      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${whobanner})` }}
        >
          <div className="absolute inset-0 bg-black/70 lg:bg-black/60" />

          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
            <h1 className="text-4xl font-bold mb-4">Request A Quote</h1>
            <div className="flex items-center gap-2 text-sm">
              <Link to="/" className="hover:underline">
                Home
              </Link>
             <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                className="mt-[2px]"
              >
                <path
                  d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
                  fill="white"
                />
              </svg>
              <span>Request A Quote</span>
            </div>
          </div>
        </div>
      </header>

      {/* Form Section */}
      <section className="flex-grow py-16 bg-gradient-to-b from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row rounded-3xl shadow-xl bg-white overflow-hidden">

            {/* Left */}
            <div className="lg:w-5/12 p-12 bg-[#282C6A] text-white">
              <h2 className="text-4xl font-extrabold">
                REQUEST A QUOTE
              </h2>
              <p className="mt-4">
                Need a Free Quote? Please Feel Free to Contact Us
              </p>

              <div className="space-y-4 pt-8">
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5" />
                  <span>+91 79932 56679</span>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5" />
                  <a
                    href="mailto:info@securxperts.com"
                    className="underline"
                  >
                    info@securxperts.com
                  </a>
                </div>
                <div className="flex gap-3">
                  <MapPin className="w-6 h-6 mt-1" />
                  <p>
                    PR R One Towers, Plot No 59, Third Floor,
                    Jayabheri Enclave-2, Gachibowli,
                    Hyderabad, Telangana 500032
                  </p>
                </div>
                
                        <div className="flex gap-3">
                  <MapPin className="w-3 h-3 mt-1" />
                  <p>
                   194 Gulson Road,
                  Coventry, England, CV1 2JD
                  <br></br>
                  United Kingdom
                  </p>
                </div>
              </div>
            </div>

            {/* Right */}
            <div className="lg:w-7/12 p-12">

              {/* {status.message && (
                <div
                  className={`mb-6 p-4 text-center rounded font-medium ${
                    status.type === "success"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {status.message}
                </div>
              )} */}

              <form onSubmit={handleSubmit} className="space-y-8">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Full Name"
                  className="w-full border-b py-2 text-lg"
                  required
                />

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  className="w-full border-b py-2 text-lg"
                  required
                />

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
                 <PhoneInput
  country="in"
  enableSearch
  value={formData.countrycode}
  onChange={(value, country) =>
    setFormData((prev) => ({
      ...prev,
      countrycode: `+${country.dialCode}`,
    }))
  }
  containerStyle={{
    display: "flex",
    alignItems: "flex-end", // ⭐ KEY FIX
  }}
  inputStyle={{
    width: "100%",
    border: "none",
    borderBottom: "1px solid #D1D5DB",
    fontSize: "18px",
    height: "42px",          // ⭐ matches other inputs
    paddingLeft: "60px",
  }}
  buttonStyle={{
    border: "none",
    background: "transparent",
    marginBottom: "2px",     // ⭐ aligns flag box to bottom
  }}
/>

                  <input
                    type="tel"

                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone Number"
                    className="w-full border-b py-2 text-lg"
                    required
                  />

                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="w-full border-b py-2 text-lg"
                    required
                  >
                    <option value="" disabled>
                      -- Select Service --
                    </option>
                    <option value="web">Web Development</option>
                    <option value="app">Mobile App Development</option>
                    <option value="design">UI/UX Design</option>
                    <option value="marketing">Digital Marketing</option>
                    <option value="consulting">Consulting</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Message"
                  rows="5"
                  className="w-full border-b py-2 text-lg"
                  required
                />

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full max-w-[180px] bg-[#282C6A] text-white py-2.5 text-sm rounded-md"
                >
                  {isSubmitting ? "Sending..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />

   

      {showModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="relative bg-white rounded-lg shadow-xl p-6 w-full max-w-md">

      {/* Close Button */}
      <button
        onClick={() => setShowModal(false)}
        className="absolute top-3 right-3 text-gray-400 hover:text-gray-700"
      >
        ✕
      </button>

      <h3
        className={`text-lg font-semibold text-center ${
          modalData.type === "success"
            ? "text-green-600"
            : "text-red-600"
        }`}
      >
        {modalData.type === "success" ? "Success" : "Error"}
      </h3>

      <p className="mt-3 text-center text-gray-700">
        {modalData.message}
      </p>
    </div>
  </div>
)}

    </div>
  );
};

export default RequestQuoteDesign;
